import { createFileRoute } from '@tanstack/react-router';
import { OldPageSeo } from './-components/page-seo';
import { useLingui } from '@lingui/react/macro';
import { Layout } from './-components/layout';
import { Header } from './-components/header';
import { Footer } from './-components/footer';
import { trpc } from '@/lib/trpc';
import { useSuspenseQuery } from '@tanstack/react-query';
import { WwwPagePending } from './-components/page-pending';

export const Route = createFileRoute('/old/privacy-policy')({
	loader: ({ context }) => {
		context.queryClient.ensureQueryData(
			trpc.core.getLegalContent.queryOptions({ type: 'privacy-policy', locale: context.locale }),
		);
	},
	component: Component,
	pendingComponent: WwwPagePending,
});

function Component() {
	const { t } = useLingui();
	const { locale } = Route.useRouteContext();
	const { data: html } = useSuspenseQuery(trpc.core.getLegalContent.queryOptions({ type: 'privacy-policy', locale }));

	return (
		<Layout>
			<Header />
			<OldPageSeo
				title={t`Privacy Policy - Worldcoo`}
				description={t`Worldcoo privacy policy. Information about the processing of personal data.`}
			/>

			<article className="unreset-tailwind mx-auto max-w-4xl p-8" dangerouslySetInnerHTML={{ __html: html }} />

			<Footer />
		</Layout>
	);
}
